module.exports = __webpack_public_path__ + "img/money.0fbd2bae.png";